module.exports = __webpack_public_path__ + "static/media/ashtein.5e1c60da.jpg";